import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import {
  CancelUserInvitationRequest,
  CancelUserInvitationResponse,
  HttpResponse,
} from "@/types";

export function useCancelUserInvitation() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      cancelUserInvitationRequest,
    }: {
      cancelUserInvitationRequest: CancelUserInvitationRequest;
    }) => {
      const path = `companies/${currentCompanyId}/user-invitations/cancel`;
      const res = await guacHttpClient.post<
        CancelUserInvitationResponse,
        HttpResponse<CancelUserInvitationResponse>,
        CancelUserInvitationRequest
      >(path, cancelUserInvitationRequest);

      return res.data;
    },
  });

  return mutation;
}
